import { cva } from 'class-variance-authority';

/**
 * Represents the style configuration for a GlowIconButton component.
 */
export const iconButtonStyle = cva(['w-fit rounded-0.5 duration-slow1 border border-solid'], {
    variants: {
        variant: {
            primary: [
                'text-text-primary-inverse fill-text-primary-inverse',
                'bg-surface-brand hover:bg-surface-brand-hover active:bg-surface-brand-pressed',
                'border-surface-brand hover:border-surface-brand-hover active:border-surface-brand-pressed border-none',
            ],
            secondary: [
                'text-text-primary fill-text-primary',
                'bg-surface-primary hover:bg-surface-primary-hover active:bg-surface-primary-pressed',
                'border-border-brand border-bold',
            ],
            tertiary: [
                'text-text-primary fill-text-primary',
                'bg-surface-primary hover:bg-surface-primary-hover active:bg-surface-primary-pressed',
                'border-border-primary border-medium',
            ],
            disabled: ['fill-text-tertiary text-text-tertiary', 'bg-background-disabled', 'border-none'],
            transparent: ['fill-text-primary text-text-primary', 'bg-surface-primary', 'border-none'],
            onElement: [
                'text-text-primary fill-text-primary',
                'bg-surface-primary hover:bg-surface-primary-hover active:bg-surface-primary-pressed',
                'border-none',
            ],
        },
        size: {
            large: 'p-0.75',
            medium: 'p-0.5',
            small: 'p-0.25',
        },
    },
    defaultVariants: {
        variant: 'primary',
        size: 'large',
    },
});
